import { GridOverlay } from "@material-ui/data-grid";
export function customNoRowsOverlay() {
  return (
    <GridOverlay>
      <div>No Data Found</div>
    </GridOverlay>
  );
}
